import React from 'react';

const MongoDB_Aggregations = () => {
  return (
    <div>
      <h1>MongoDB_Aggregations Component</h1>
      <p>This is the MongoDB_Aggregations page.</p>
    </div>
  );
};

export default MongoDB_Aggregations;
